import React, { useEffect, useMemo } from 'react'
import './qrCodePopup.scss'
import SoundIconSvg from "../assets/sound-icon.svg";
import QRErrorJSON from "../assets/qr-error.json";
import RenderAnimation from '../../teacherDashboard/teacher/lotties/RenderAnimation';
import { useAuthSigninState } from '../state';
import IncorrectQRCode from '../assets/incorrect-qrcode.mp3'

const QRcodePopup = ({errorInfo = null, setLoading, setError}: any) => {
  const { showQRPopup, setShowQRPopup } = useAuthSigninState()
  const audio = useMemo(() => new Audio(IncorrectQRCode), []);
  
  const QRCodeExpired = useMemo(() => {
    if(errorInfo === "This QR code is expired. Please contact your teacher."){
      return true
    }
    else {
      return false
    }
  }, [errorInfo])

  useEffect(() => {
    if (errorInfo || showQRPopup) {
      audio.play()
      trackEventsForGuests("Viewed SplashLearn QR Code Required Popup", { "mp_login_user_type": "student" }, { send_mixpanel: true })
    }
    return () => {
      audio.pause()
    }
  }, [audio, errorInfo, showQRPopup])

  if(!errorInfo && !showQRPopup){
    return null
  }

  const loginViaClassCode = () => {
    window.location.hash = "#student-klasscode?fromPage=QR code Required Popup";
    trackEventsForGuests("Interacted SplashLearn QR code Required Popup", { "mp_login_user_type": "student", "Clicked on": "Login via class code" }, { send_mixpanel: true })
  }

  const scanAgain = (clickedOn: string) => {
    setLoading(false)
    setError(null)
    setShowQRPopup(false)
    trackEventsForGuests("Interacted SplashLearn QR code Required Popup", { "mp_login_user_type": "student", "Clicked on": clickedOn }, { send_mixpanel: true })
  }


  return (
    <div className='qr-code-popup'>
      <div className="qr-code-overlay">
        <div className="qr-code-popup">
        <button className="iconcust-iconCross cross-icon" onClick={() => scanAgain("Cross")} aria-label="Close popup" />
          <SoundIconSvg 
            className="sound-icon" 
            onClick={() => audio.play()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                audio.play();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Play sound"
          />
          <h4>{QRCodeExpired ? "The QR code is expired" : "SplashLearn QR code required"}</h4>
          <p>{QRCodeExpired ? "Ask your teacher for help.": "Please make sure that you are scanning the SplashLearn QR code."}</p>
          <div id="qr-err-animation"/>
          <RenderAnimation
            animationJSON = {QRErrorJSON}
            animationName = {'icon-animation'}
            animationDivId = {'qr-err-animation'}
          />
          <div className="qr-code-btns">
            <button className={`${!QRCodeExpired ? "class-code": ""}`} onClick={loginViaClassCode}>
              Login via class code
            </button>
            {!QRCodeExpired ? <button className='scan-again' onClick={() => scanAgain("Retry")}>
              Scan again
            </button> : null}
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default QRcodePopup